
const de = {
  // Navigation
  'navigation.home': 'Home',
  'navigation.music': 'Musik',
  'navigation.about': 'Über mich',
  'navigation.videos': 'Videos',
  'navigation.contact': 'Kontakt',

  // Home page
  'home.hero_title_1': 'JEAN-CLAUDE',
  'home.hero_title_2': 'BASTOS',
  'home.hero_subtitle': 'UK ELECTRONIC POWERHOUSE',
  'home.hero_description': 'Erschafft high-energy Tracks mit cinematic Edge',
  'home.cta_experience': 'ERLEBE DEN SOUND',
  'home.cta_connect': 'CONNECT',
  'home.latest_releases': 'NEUESTE RELEASES',
  'home.latest_releases_subtitle': 'HIGH-ENERGY ELECTRONIC TRACKS MIT CINEMATIC EDGE',
  'home.track_1_title': 'Break the Ground',
  'home.track_1_desc': 'EXPLOSIVE PROGRESSIVE HOUSE MIT DEVASTATING DROPS',
  'home.track_2_title': 'Running Free',
  'home.track_2_desc': 'SUMMER ANTHEM MIT EUPHORIC UPLIFTING MELODIES',
  'home.track_3_title': 'When We Loved',
  'home.track_3_desc': 'EMOTIONAL MELODIC JOURNEY MIT AMBIENT BREAKDOWNS',
  'home.about_title_1': 'UK ELECTRONIC',
  'home.about_title_2': 'MUSIC PRODUCER',
  'home.about_text_1': 'Jean-Claude Bastos ist eine UK-basierte Electronic Powerhouse, die high-energy Tracks mit cinematic Edge erschafft. Er verbindet Elemente von progressive House, melodic Techno und ambient-inspirierten Breakdowns.',
  'home.about_text_2': 'Sein Sound ist designed, um sowohl Crowds als auch Headphones zu bewegen, gleichermaßen geeignet für Electronic Music Enthusiasten und Late-Night Playlists.',
  'home.cta_discover': 'ENTDECKE DIE JOURNEY',
  'home.quote': 'Meine Lieblingssongs haben sich immer angefühlt wie POSTKARTEN VON ORTEN, wo ich nie war. Das ist was ich versuche zu erschaffen—SOUNDTRACKS FÜR ORTE, die nur existieren, wenn du deine Augen schließt.',
  'home.quote_author': '— JEAN-CLAUDE BASTOS',
  'home.final_cta_title': 'ERLEBE DEN SOUND',
  'home.final_cta_subtitle': 'ERKUNDE DEN SOUND. FÜHLE DEN BUILD. WERDE TEIL DER JOURNEY.',
  'home.cta_listen': 'JETZT HÖREN',
  'home.cta_website': 'OFFIZIELLE WEBSITE',

  // About page
  'about.hero_title': 'Über mich',
  'about.hero_subtitle': 'Die Geschichte hinter der Musik und die Journey von Jean-Claude Bastos',
  'about.main_title': 'Jean-Claude Bastos',
  'about.main_text_1': 'Jean-Claude Bastos ist ein UK-basierter Electronic Music Producer, der high-energy Tracks mit cinematic Edge erschafft. Er verbindet Elemente von progressive House, melodic Techno und ambient-inspirierten Breakdowns, sein Sound ist designed, um sowohl Electronic Music Fans als auch Headphones zu bewegen.',
  'about.main_text_2': 'Mit frühen Releases wie Running Free, Break the Ground und When We Loved hat Bastos schnell eine Reputation für immersive Production und vielseitige Energy aufgebaut — perfekt für Electronic Music Enthusiasten und Late-Night Playlists.',
  'about.main_text_3': 'Ob du seine Beats zum ersten Mal entdeckst oder jedem neuen Drop folgst, diese Journey repräsentiert den offiziellen Hub für alles rund um Jean-Claude Bastos. Erkunde den Sound. Fühle den Build. Werde Teil der Journey.',
  'about.music_style': 'Musik Style',
  'about.music_style_desc': 'Progressive House, Melodic Techno & Ambient Breakdowns',
  'about.based_in': 'Ansässig in',
  'about.based_in_desc': 'Vereinigtes Königreich',
  'about.quote': 'Beats sind für mich wie Farben – jede Melodie malt eine neue Stimmung. Meine Musik soll Momente einfangen, die man nicht mit Fotos, sondern nur mit Klängen festhalten kann.',
  'about.quote_author': '– DJ Jean-Claude Bastos',
  'about.journey_title': 'Musikalische Journey',
  'about.journey_subtitle': 'Von frühen Inspirationen bis zu Breakthrough Releases',
  'about.journey_1_title': 'Frühe Anfänge',
  'about.journey_1_desc': 'Begonnen mit einer Passion für emotionale Soundscapes, die Listeners zu neuen Welten transportieren',
  'about.journey_2_title': 'Breakthrough Releases',
  'about.journey_2_desc': 'Running Free, Break the Ground und When We Loved etablierten seinen einzigartigen Sound in der Electronic Music Scene',
  'about.journey_3_title': 'Zukunftsvision',
  'about.journey_3_desc': 'Erweitert kontinuierlich Grenzen mit immersiver Production und cinematic Electronic Experiences',
  'about.website_cta_title': 'Besuche die offizielle Website',
  'about.website_cta_desc': 'Für exklusiven Zugang zu neuer Musik, Streaming Links, Video Content und Behind-the-Scenes Einblicke in Jean-Claudes kreativen Prozess.',

  // Contact page
  'contact.hero_title': 'Kontakt',
  'contact.hero_subtitle': 'Für Presseanfragen, Kollaborationen oder einfach zum Vernetzen',
  'contact.get_in_touch': 'Kontakt aufnehmen',
  'contact.location_title': 'Standort',
  'contact.location_desc': '📍 Vereinigtes Königreich',
  'contact.email_title': 'E-Mail',
  'contact.email_desc': '📧 Verfügbar über Kontaktformular',
  'contact.specialization_title': 'Spezialisierung',
  'contact.specialization_desc': 'Progressive House • Melodic Techno • Electronic Music Production',
  'contact.website_title': 'Offizielle Website',
  'contact.follow_title': 'Folge der Journey',
  'contact.form_title': 'Nachricht senden',
  'contact.form_name': 'Vollständiger Name *',
  'contact.form_name_placeholder': 'Dein vollständiger Name',
  'contact.form_email': 'E-Mail Adresse *',
  'contact.form_email_placeholder': 'deine.email@beispiel.com',
  'contact.form_message': 'Nachricht * (max. 500 Zeichen)',
  'contact.form_message_placeholder': 'Erzähle mir von deiner Presseanfrage, Kollaborationsideen oder sag einfach Hallo...',
  'contact.form_characters': 'Zeichen',
  'contact.form_sending': 'Wird gesendet...',
  'contact.form_send': 'Nachricht senden',
  'contact.form_success': 'Danke! Deine Nachricht wurde erfolgreich gesendet.',
  'contact.form_error': 'Fehler beim Senden der Nachricht. Bitte versuche es erneut.',
  'contact.services_title': 'Kreativer Fokus',
  'contact.services_subtitle': 'High-energy Electronic Music Creation und Production',
  'contact.service_1_title': 'Musikproduktion',
  'contact.service_1_desc': 'High-energy Electronic Tracks designed, um sowohl Crowds als auch Headphones zu bewegen, mit cinematic Edge',
  'contact.service_2_title': 'Sound Design',
  'contact.service_2_desc': 'Immersive Audio Experiences mit melodic Techno und progressive House Elementen',
  'contact.service_3_title': 'Kreative Kollaborationen',
  'contact.service_3_desc': 'Zusammenarbeit mit anderen Artists und Producers für innovative Electronic Music Projekte',

  // Music page
  'music.hero_title': 'Musik',
  'music.hero_subtitle': 'Entdecke die neuesten Releases und Tracks von Jean-Claude Bastos',
  'music.latest_releases': 'NEUESTE RELEASES',
  'music.more_tracks': 'WEITERE TRACKS',
  'music.play_on': 'Abspielen auf',
  'music.duration': 'Dauer',

  // Videos page
  'videos.hero_title': 'Videos',
  'videos.hero_subtitle': 'Musikvideos und kreativer Content von Jean-Claude Bastos',
  'videos.music_videos': 'Musikvideos',
  'videos.official_content': 'Offizielle Musikvideos und visueller Content von Jean-Claude Bastos',
  'videos.subscribe_youtube': 'Auf YouTube abonnieren',
  'videos.watch_youtube': 'Auf YouTube ansehen',
  'videos.views': 'Aufrufe',
  'videos.duration': 'Dauer',
  'videos.stay_connected': 'Verbunden bleiben',
  'videos.subscribe_message': 'Abonniere den YouTube Kanal für exklusiven Content und die neuesten Releases',
  'videos.subscribe_now': 'Jetzt abonnieren',
  'videos.listen_music': 'Musik hören',

  // Footer
  'footer.made_with': 'Erstellt mit',
  'footer.rights': 'Alle Rechte vorbehalten.',

  seo: {
    title: 'Jean-Claude Bastos | UK DJ & EDM Produzent',
    description: 'Jean-Claude Bastos ist ein UK-basierter DJ und EDM-Produzent, der Fans weltweit mit energiegeladenen Beats und Sommerhymnen begeistert. Entdecke seine Musik, Mixes und neuesten Releases.',
    keywords: 'Jean-Claude Bastos, UK DJ, EDM Produzent, Electronic Dance Music, Progressive House, Break the Ground, Running Free, When We Loved, UK Electronic Music, EDM Künstler, Electronic Music Producer',
    home: {
      title: 'Jean-Claude Bastos | UK Electronic Music Producer & DJ',
      description: 'Erlebe die elektrisierende Welt von Jean-Claude Bastos, UKs aufstrebender Electronic Music Sensation. High-energy EDM Tracks, Progressive House Beats und cinematic Electronic Experiences. Streame Break the Ground, Running Free und When We Loved.',
      keywords: 'Jean-Claude Bastos, UK Electronic Music, EDM Produzent, Progressive House, Break the Ground, Running Free, When We Loved, UK DJ, Electronic Dance Music'
    },
    music: {
      title: 'Musik | Jean-Claude Bastos - Neueste EDM Tracks & Electronic Releases',
      description: 'Entdecke Jean-Claude Bastos\' kompletten Musikkatalog. Streame und entdecke die neuesten EDM Tracks inklusive Break the Ground, Running Free, When We Loved und weitere Progressive House Anthems.',
      keywords: 'Jean-Claude Bastos Musik, EDM Tracks, Progressive House, Electronic Music Releases, Break the Ground, Running Free, When We Loved, UK Electronic Music'
    },
    videos: {
      title: 'Musikvideos | Jean-Claude Bastos - Offizielle Electronic Music Videos',
      description: 'Schaue Jean-Claude Bastos\' offizielle Musikvideos inklusive Break the Ground, Running Free, When We Loved und Firestarter Hearts. High-Quality Electronic Music Video Content.',
      keywords: 'Jean-Claude Bastos Videos, Electronic Music Videos, Break the Ground Video, Running Free Video, When We Loved Video, EDM Musikvideos, UK Electronic Music'
    },
    about: {
      title: 'Über Jean-Claude Bastos | UK Electronic Music Producer Biografie',
      description: 'Erfahre mehr über Jean-Claude Bastos, den UK-basierten Electronic Music Producer, der high-energy Tracks mit cinematic Edge erschafft. Entdecke seine musikalische Journey, Style und künstlerische Vision.',
      keywords: 'Jean-Claude Bastos Biografie, UK Electronic Music Producer, Progressive House Artist, Melodic Techno, Electronic Music Biografie, UK DJ Hintergrund'
    },
    contact: {
      title: 'Kontakt Jean-Claude Bastos | Electronic Music Producer Anfragen',
      description: 'Kontaktiere Jean-Claude Bastos für Presseanfragen, Musik-Kollaborationen, Buchungen und Geschäftsmöglichkeiten. Kontaktiere den UK Electronic Music Producer heute.',
      keywords: 'Jean-Claude Bastos Kontakt, Electronic Music Producer Kontakt, UK DJ Buchung, Musik Kollaboration, Presseanfragen, EDM Producer Kontakt'
    }
  }
};

export default de;
